/*
 * The JS switch point.
 *
 * ONE place to point the app at the active site. Switching brand means editing
 * the two lines below — nothing else. Do not replace this with a dynamic
 * `import(process.env.SITE)`: next/font and Tailwind both need statically
 * analysable paths.
 */

export { default as site } from './sites/organic-seeds'
export { fonts } from './sites/organic-seeds/fonts'
